<template>
  <BaseDialog
    title="下載 QR code"
    width="400px"
    btn1="下載 QR Code"
    btn2="關閉"
    :btn1Loading="loading"
    @close="$emit('close')"
    @cancel="$emit('close')"
    @confirm="onDownload"
  >
    <div v-loading="qrLoading" class="qr-code-container">
      <img v-if="!qrLoading" :src="qrcodeImg" alt="QR Code">
      <GrayBlockContainer class="qr-info">
        <BobDisplayForm
          :fields="displayFields"
          :contentClasses="['text-right', 'w-full']"
        />
      </GrayBlockContainer>
    </div>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useShop } from '@/use/shop'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import { GenerateMiezoAccessControlPasswordQRCode } from '@/api/miezoAccessControlPassword'
import { useQRCode } from '@vueuse/integrations/useQRCode'
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import BobDisplayForm from '@/components/BobDisplayForm.vue'

export default defineComponent({
  name: 'ViewQRCodeDialog',
  components: {
    BaseDialog,
    GrayBlockContainer,
    BobDisplayForm,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  setup (props) {
    const { shopId } = useShop()
    const loading = ref(false)
    const qrLoading = ref(false)
    const qrCodeText = ref('')
    const qrcodeImg = useQRCode(qrCodeText, {
      width: 200,
      margin: 0,
    })

    const accessControlNames = computed(() => {
      const names = (props.data?.MiezoAccessControls || []).map((ac) => ac.name)
      return names.length > 0 ? names.join('、') : '-'
    })

    // 取得 QR Code 文字並產生圖片
    const fetchQRCode = async () => {
      qrLoading.value = true
      const [res, err] = await GenerateMiezoAccessControlPasswordQRCode({
        shopId: shopId.value,
        id: props.data.id,
      })
      qrLoading.value = false

      if (err) {
        window.$message.error(err)
        return
      }

      qrCodeText.value = res.qrCode
    }

    // 下載 QR Code
    const onDownload = () => {
      if (!qrcodeImg.value) return

      loading.value = true
      const link = document.createElement('a')
      link.download = `${accessControlNames.value}_${props.data.name}.png`
      link.href = qrcodeImg.value
      link.click()
      loading.value = false
    }

    const displayFields = computed(() => [
      {
        label: '名稱',
        prop: 'name',
        body: {
          render: () => props.data.name,
        },
      },
      {
        label: '門禁',
        prop: 'accessControlNames',
        body: {
          render: () => accessControlNames.value,
        },
      },
    ])

    onMounted(async () => {
      await fetchQRCode()
    })

    return {
      loading,
      qrLoading,
      qrcodeImg,
      accessControlNames,
      onDownload,
      displayFields,
    }
  },
})
</script>

<style lang="postcss" scoped>
.qr-code-container {
  @apply flex flex-col items-center gap-[20px];
}

.qr-canvas {
  @apply mx-auto;
}

.qr-info {
  @apply flex flex-col gap-[8px] w-full px-[10px] py-0;
}
</style>
